import {CoreEventsMap} from '@gongxigames/framework/core';
import {StrictAutoplayEvents} from '@gongxigames/framework/slot/events/StrictAutoplayEvents';
import {StrictWinPresentationEvents} from '@gongxigames/framework/slot/events/StrictWinPresentationEvents';
import {FlowEvents} from '@gongxigames/framework/slot/events/FlowEvents';
import {GameHistoryEvents} from '@gongxigames/framework/slot/events/GameHistoryEvents';
import {StrictPromotionEvents} from '@gongxigames/framework/slot/events/StrictPromotionEvents';
import {UIEvents} from '@gongxigames/framework/slot/events/UIEvents';
import {SlotEvents} from '@gongxigames/framework/slot/events/SlotEvents';
import {BuyFeatureEvents} from '@gongxigames/framework/slot/events/BuyFeatureEvents';
import { PromotionEvents } from '@gongxigames/framework/promotions';
import {SlotGameEvents} from '@gongxigames/framework/slot/events/SlotGameEvents';
import {WindowEvents} from '@gongxigames/framework/slot/events/WindowEvents';
import {CollapseEvents} from '@gongxigames/framework/slot/events/CollapseEvents';
import {NetworkEvents} from '@gongxigames/framework/slot/events/NetworkEvents';
import {ReelsCascadingEvents} from '@gongxigames/framework/slot/events/ReelsCascadingEvents';

export type GlobalEventsMap =
    CoreEventsMap &
    FlowEvents &
    ReelsCascadingEvents &
    UIEvents &
    StrictAutoplayEvents &
    StrictWinPresentationEvents &
    StrictPromotionEvents &
    GameHistoryEvents &
    SlotEvents &
    BuyFeatureEvents &
    PromotionEvents &
    SlotGameEvents &
    WindowEvents &
    CollapseEvents &
    NetworkEvents;

export type GlobalEventsMapForBackwardCompatibility = GlobalEventsMap & {
    [key: string | symbol]: any;
};
